<template>
  <div class="expressInfo-wrap-container">
    <van-nav-bar
      title="修改快递信息"
      left-arrow
      @click-left="goBack"
      :class="[
        'rewrite-am-navbar-light',
        not_iphonex ? 'notrem-rewrite-am-navbar-light-notiphonex' : '',
        iphonex && !not_iphonex ? 'notrem-rewrite-am-navbar-light-iphonex' : '',
      ]"
    />
    <div
      :class="[
        'expressInfo-wrap',
        not_iphonex ? 'notrem-expressInfo-wrap-notiphonex' : '',
        iphonex && !not_iphonex ? 'notrem-expressInfo-wrap-iphonex' : '',
      ]"
    >
      <div class="card-box">
        <!-- 快递表单组件 -->
        <ExpressFormComponent
          ref="expressFormComponent"
          :bizId="bizId"
        ></ExpressFormComponent>
      </div>
      <div class="footer-fixed-box">
        <div class="submit-btn" @click="submitData">保存</div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapMutations } from "vuex";
import ExpressFormComponent from "./components/expressFormComponent";
import appUtil from "../../utils/appUtil";
export default {
  name: "expressInfoEdit",
  data() {
    return {
      bizId: "",
      tab: "",
      not_iphonex: window.navigator.userAgent.includes("not_iphonex"),
      iphonex: window.navigator.userAgent.includes("iphonex"),
    };
  },
  components: {
    ExpressFormComponent,
  },
  computed: {},
  created() {
    this.tab = this.$route.query.tab ? this.$route.query.tab : "";
    this.bizId = this.$route.query.mrbNum ? this.$route.query.mrbNum : "";
    let isApp = new appUtil().isApp();
    if (isApp == "android" || isApp == "ios") {
      window.dhsdk.isShowNavigation({
        show: false,
      });
    }
  },
  mounted() {
    window.scrollTo(0, 0);
  },
  methods: {
    ...mapMutations({
      changeLoading: "changeLoading",
    }),
    goBack() {
      history.go(-1);
    },
    submitData() {
      let expressComponent = this.$refs.expressFormComponent;
      if (expressComponent.formValidator()) {
        this.changeLoading(true);
        this.$api.my
          .editExpressInfoSubmit(
            {
              bizId: this.bizId,
              expressId: expressComponent.expressId.trim(),
              expressCompany: expressComponent.expressCompany,
              consignee: expressComponent.consignee,
              consigneePhone: expressComponent.consigneePhone,
            },
            { headers: { "Content-Type": "application/json" } }
          )
          .then((res) => {
            this.changeLoading(false);
            if (res.ret) {
              this.$toast("修改成功");
              setTimeout(function () {
                history.go(-1);
              }, 250);
            } else {
              this.$toast(res.msg);
            }
          });
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.expressInfo-wrap-container {
  min-height: 100%;
  background: rgba(244, 244, 244, 1);
  .fixNav {
    color: #333;
    position: fixed;
    top: 0;
    right: 0;
    left: 0;
    z-index: 999;
    height: 44px;
    box-sizing: content-box;
    border-bottom: 1px solid #f3f3f3;
  }

  .expressInfo-wrap {
    padding: 57px 12px 150px 12px;
    background: rgba(244, 244, 244, 1);
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: rgba(51, 51, 51, 1);
    line-height: 14px;
    min-height: 100%;

    .flex-between {
      justify-content: space-between;
    }
    .card-box {
      padding: 0 0.32rem;
      background: rgba(255, 255, 255, 1);
      border-radius: 6px;
    }
    .footer-fixed-box {
      position: fixed;
      width: 100%;
      left: 0;
      bottom: 0;
      background: rgba(244, 244, 244, 1);
      padding: 12px 20px 25px;
      .submit-btn {
        font-size: 16px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: rgba(255, 255, 255, 1);
        height: 44px;
        background: rgba(205, 0, 20, 1);
        border-radius: 4px;
        text-align: center;
        padding-top: 15px;
      }
    }
  }
  .notrem-expressInfo-wrap-iphonex {
    padding-top: calc(1.173333rem + 40px + 0.4rem);
  }

  .notrem-expressInfo-wrap-notiphonex {
    padding-top: calc(1.173333rem + 20px + 0.4rem);
  }
  .rewrite-am-navbar-light {
    color: #333;
    position: fixed;
    top: 0;
    right: 0;
    left: 0;
    z-index: 999;
    height: 44px;
    box-sizing: content-box;
    border-bottom: 1px solid #f3f3f3;
    .am-navbar-title {
      font-size: 18px;
      color: #333;
    }
    .am-navbar-left {
      padding-left: 11px;
    }
    .am-icon-md {
      width: 29px;
      height: 29px;
    }
    &-iphonex {
      padding-top: 40px;
    }
    &-notiphonex {
      padding-top: 20px;
    }
  }
}
.notrem-rewrite-am-navbar-light-iphonex {
  padding-top: 40px;
}
.notrem-rewrite-am-navbar-light-notiphonex {
  padding-top: 20px;
}
</style>
